import { APIResults, AssemblyConfig } from "./sharedinterfaces";

export class ItemHealth {
	public overallHealth: number;
	public rtbHealth: number;
	public fdmHealth: number;
	public mdHealth: number;

	public static FromFleet(fleet: APIResults.Fleet): ItemHealth {
		const ih = new ItemHealth();
		ih.rtbHealth = fleet.rtbhealth;
		let fdmHealth = fleet.assets.some(asset => asset.exceedancecount > 0) ? AssemblyConfig.HumsHiThreshold.Warning : 0;
		fdmHealth = Math.max(fdmHealth, fleet.assets.some(asset => asset.severeexceedancecount > 0) ? AssemblyConfig.HumsHiThreshold.Alarm : 0);
		ih.fdmHealth = fdmHealth;
		ih.mdHealth = fleet.mdmax;
		ih.overallHealth = Math.max(ih.rtbHealth, ih.fdmHealth, ih.mdHealth);
		return ih;
	}

	public static FromAsset(asset: APIResults.FleetAsset): ItemHealth {
		const ih = new ItemHealth();
		ih.rtbHealth = asset.rtbhealth;
		let fdmHealth = asset.exceedancecount > 0 ? AssemblyConfig.HumsHiThreshold.Warning : 0;
		fdmHealth = Math.max(fdmHealth, asset.severeexceedancecount > 0 ? AssemblyConfig.HumsHiThreshold.Alarm : 0);
		ih.fdmHealth = fdmHealth;
		ih.mdHealth = asset.mdmax;
		ih.overallHealth = Math.max(ih.rtbHealth, ih.fdmHealth, ih.mdHealth);
		return ih;
	}

	public Icon(component: string): string {
		switch (component) {
			case "md":
				return this.getIcon(this.mdHealth);
			case "fdm":
				return this.getIcon(this.fdmHealth);
			case "rtb":
				return this.getIcon(this.rtbHealth);
			default:
				return this.getIcon(this.overallHealth);
		}
	}

	public Foreground(component: string): string {
		switch (component) {
			case "md":
				return ItemHealth.GetForegroundColor(this.mdHealth);
			case "fdm":
				return ItemHealth.GetForegroundColor(this.fdmHealth);
			case "rtb":
				return ItemHealth.GetForegroundColor(this.rtbHealth);
			default:
				return ItemHealth.GetForegroundColor(this.overallHealth);
		}
	}

	public Background(component: string): string {
		switch (component) {
			case "md":
				return ItemHealth.GetBackgroundColor(this.mdHealth);
			case "fdm":
				return ItemHealth.GetBackgroundColor(this.fdmHealth);
			case "rtb":
				return ItemHealth.GetBackgroundColor(this.rtbHealth);
			default:
				return ItemHealth.GetBackgroundColor(this.overallHealth);
		}
	}

	public static GetForegroundColor(health: number): string {
		if (health === undefined || health === null) {
			return "status-blank-fg";
		} else if (health >= AssemblyConfig.HumsHiThreshold.Alarm) {
			return "status-error-fg"
		} else if (health >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "status-warning-fg"
		} else {
			return "status-ok-fg";
		}
	}

	public static GetBackgroundColor(health: number): string {
		if (health === undefined || health === null) {
			return "status-blank-bg";
		} else if (health >= AssemblyConfig.HumsHiThreshold.Alarm) {
			return "status-error-bg"
		} else if (health >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "status-warning-bg"
		} else {
			return "status-ok-bg";
		}
	}

	private getIcon(health: number): string {
		if (health >= AssemblyConfig.HumsHiThreshold.Alarm) {
			return "icon-health-alarm"
		} else if (health >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "icon-health-warning"
		} else {
			return "icon-health-ok";
		}
	}
}
